import styled from 'styled-components';

const MyPageContainer = styled.div`
  padding: 1.2rem;
`;

export default MyPageContainer;
